import React, { useEffect, useState } from "react";
import classes from "./login.module.css";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { Link } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ClipLoader from "react-spinners/PulseLoader";
import useRandomCity from "./useRandomcity";

function LoginPage() {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);

	//importing and using custom hook
	//Random city
	const [city_loading, city_error, city, refreshCity] = useRandomCity();

	// check if image has loaded
	const [imageLoaded, setImageLoaded] = useState(false);
	const [image, setImage] = useState("");

	// Refresh city every 20 seconds
	useEffect(() => {
		const interval = setInterval(refreshCity, 70000);
		return () => clearInterval(interval);
	}, [refreshCity]);

	//Pre load image
	useEffect(() => {
		if (city_loading || !city?.image) {
			return;
		}

		const image = new Image();
		image.src = city?.image;
		image.onload = () => {
			setImageLoaded(true);
			setImage(city?.image);
		};
	}, [city?.image, city_loading]);

	// load css classes
	const fade_in_classes = [classes.loginImg];

	if (image && imageLoaded) {
		fade_in_classes.push(classes.loaded);
	}

	const handleLogin = async (e) => {
		e.preventDefault();

		try {
			setLoading(true);
			setError(false);
			const auth = getAuth();
			await signInWithEmailAndPassword(auth, email, password);
		} catch (error) {
			console.log("Auth Error", error);
			alert(error);
			setError(true);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className={classes.loginform}>
			<Row>
				<Col sm={6} md={6} lg={7} xl={8} xxl={8}>
					{!city_loading && city_error && (
						<div className={classes.errorImg}>
							<img src="./images/chiang-mi.jpg" alt="chiang mi" />
						</div>
					)}

					{city_loading && (
						<div className={classes.loadingAnimation}>
							<ClipLoader
								color={"#007FFF"}
								loading={city_loading}
								size={10}
								aria-label="Loading Spinner"
								data-testid="loader"
							/>
						</div>
					)}

					{!city_loading && !city_error && (
						<div className={fade_in_classes.join(" ")}>
							{imageLoaded && (
								<img src={image} alt={city?.address} />
							)}
						</div>
					)}
				</Col>
				<Col sm={6} md={6} lg={5} xl={4} xxl={4}>
					<div className={classes.loginContainer}>
						<h2
							style={{
								marginBottom: "1rem",
								marginTop: "1rem",
								textAlign: "center",
							}}
						>
							Welcome Back!
						</h2>
						<form onSubmit={handleLogin}>
							<div className={classes.inputContainer}>
								{error && (
									<Alert
										style={{ textAlign: "center" }}
										variant="danger"
									>
										Sorry, there was an error, please try
										again
									</Alert>
								)}
								<label style={{ fontWeight: "bold" }}>
									Email
								</label>
								<input
									type="email"
									placeholder="Email"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									required
								/>
								{/* {renderErrorMessage("uname")} */}
							</div>
							<div className={classes.inputContainer}>
								<label style={{ fontWeight: "bold" }}>
									Password
								</label>
								<input
									type="password"
									placeholder="Password"
									value={password}
									onChange={(e) =>
										setPassword(e.target.value)
									}
									required
								/>
								{/* {renderErrorMessage("pass")} */}
							</div>

							<button
								className={classes.loginBut}
								type="submit"
								disabled={loading}
							>
								{loading ? (
									<>
										{"Loading... "}
										<Spinner
											as="span"
											animation="border"
											size="sm"
											role="status"
											aria-hidden="true"
										/>
									</>
								) : (
									"Login"
								)}
							</button>
							<p
								style={{
									textAlign: "center",
									paddingTop: "0px",
								}}
							>
								Don't have an account? <br />
							</p>
							<div
								style={{
									textAlign: "center",
									marginTop: "0px",
								}}
							>
								<Link
									className={classes.link}
									style={{
										marginLeft: "auto",
										marginRight: "auto",
									}}
									to="/signup"
								>
									Sign Up
								</Link>
							</div>
						</form>
					</div>
				</Col>
			</Row>
		</div>
	);
}

export default LoginPage;
